import React from "react";
import { formatUtcDateTime } from "../../utils/formatting";
import { useSimulationStore } from "../../store/simulationStore";
import { useSceneStore } from "../../store/sceneStore";
import { describeScale } from "../../utils/scaling";

interface AppHeaderProps {
  onToggleFullscreen: () => void;
}

export function AppHeader({ onToggleFullscreen }: AppHeaderProps) {
  const date = useSimulationStore((s) => s.currentDateUtc);
  const precisionMode = useSimulationStore((s) => s.precisionMode);
  const fps = useSceneStore((s) => s.fps);
  const isPlaying = useSimulationStore((s) => s.isPlaying);

  return (
    <header className="tls-astro-header">
      <div className="tls-astro-header-meta">
        <span>{formatUtcDateTime(date)}</span>
        <span className="tls-astro-badge">
          {precisionMode === "kepler" ? "Modo aproximado" : "Efemérides"}
        </span>
        <span>{isPlaying ? "▶" : "❚❚"}</span>
        <span>{fps} FPS</span>
        <span title={describeScale()}>1000 km = 1 mm</span>
        <button type="button" onClick={onToggleFullscreen}>
          Tela cheia
        </button>
      </div>
    </header>
  );
}
